import { render } from "./YouTubePublishButton.vue?vue&type=template&id=cfc5282c&scoped=true"
import script from "./YouTubePublishButton.vue?vue&type=script&lang=js"
export * from "./YouTubePublishButton.vue?vue&type=script&lang=js"

import "./YouTubePublishButton.vue?vue&type=style&index=0&id=cfc5282c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc5282c"]])

export default __exports__